var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 19,
    fill: "white",
    stroke: "#FF8C69",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5004 13.9001H18.9004C16.4151 13.9001 14.4004 15.9149 14.4004 18.4001V31.6001C14.4004 34.0854 16.4151 36.1001 18.9004 36.1001H32.1004C34.5857 36.1001 36.6004 34.0854 36.6004 31.6001V25.0001",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9783 15.1213C31.1499 13.9497 33.0494 13.9497 34.2209 15.1213L35.2816 16.182C36.4532 17.3536 36.4532 19.253 35.2816 20.4246L26.1197 29.5866C25.8715 29.8347 25.5443 29.988 25.1948 30.0197L21.6946 30.3379C20.7617 30.4227 19.9802 29.6412 20.065 28.7083L20.3832 25.2081C20.4149 24.8586 20.5682 24.5314 20.8164 24.2832L29.9783 15.1213Z",
    stroke: "#213332",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.75V16.75C29.4579 19.1447 31.3553 21.0421 33.75 22V22",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfile);
export default __webpack_public_path__ + "static/media/update_profile.ba31527151b0f86c307d27bb2f15d684.svg";
export { ForwardRef as ReactComponent };